export default __webpack_public_path__ + "static/media/ban-mobile-image-3.1bcaa4f9.jpg";